/* @flow */
import { requestAsync } from 'redux-query';

import * as q from './queries';

export function fetchAutocompleteLocationInfo(googleId: string, address2: ?string) {
  return requestAsync(q.fetchAutocompleteLocationInfo(googleId, address2));
}

export function fetchLocation(id: string) {
  return requestAsync(q.fetchLocation(id));
}



// WEBPACK FOOTER //
// ./src/redux/locations/actions.js